import NewReturnBoxComponent from './components/new-return-box';
import ShipmentsFilterComponent from './components/shipments-filter';

import './styles/new-return-box.scss';
import './styles/banana-filter.scss';

export const NewReturnBox = NewReturnBoxComponent;
export const ShipmentsFilter = ShipmentsFilterComponent;
